module.exports = __webpack_public_path__ + "static/img/female-bg-pt.a5d699b9.png";